import React, { useState, useEffect } from 'react';
import { tableData, columns } from './testy/danedowyliczen';
import { CalculateInterest } from './PaymentRate';
import { Calculate } from './PaymentRate';
import TaxForm from '../TaxForm';




function Millennium() {



 
let arr = [];
let data = 0;

  for (let i = 0; i < 40; i++) {
    
    arr.push({id: i, data: data});
    
 }
  
  return (
    <>
    <TaxForm/>
      <ul>
      {arr.map((item,i)=>{   
          console.log(arr);
                  return(
                <li key={i}>{i.id} - {item.data = <CalculateInterest creditValue={300000} id={i} LTV={0.75}/>}
                
                                     
                </li>
                )}
                ).sort((a,b)=> a.data - b.data)}
               
      </ul>
      
    </>
  );
}



export default Millennium;


